import React, { useMemo, useState } from 'react';
import * as IoC from 'typescript-ioc';
import './filter-pill.scss';
import Text from '../../../../global/text/text';
import { CloseIcon } from '../../../../global/icons/icons';
import { IConfigurationFilter, ISelectableFilter } from '../../../../../api/reports.dao';
import classNames from 'classnames';
import { getReportFilterText } from '../../../../../infrastructure/utils/report.utils';
import { IGlobalStorage } from '../../../../../infrastructure/global-storage';

export interface IProps {
    filter: IConfigurationFilter;
    clear: (filter: ISelectableFilter) => void;
    select: (filter: ISelectableFilter) => void;
    isSelected: boolean;
    customText?: string | JSX.Element;
    availableFilterTypes: ISelectableFilter[];
}

const FilterPill = (props: IProps) => {
    const globalStorage: IGlobalStorage = IoC.Container.get(IGlobalStorage);
    const [isDeleteHovered, setIsDeleteHovered] = useState(false);

    const {
        filter,
        clear,
        select,
        isSelected,
        customText,
        availableFilterTypes,
    } = props;

    const timeZone = useMemo(() => globalStorage.getEvent().timeZone, [globalStorage.getEvent()]);
    const currentFilterConfiguration = availableFilterTypes.find(el => el.field === filter.field);

    const getOperatorText = () => {
        let operatorText = '';

        switch (filter.operator) {
            case 'IN':
            case 'CONTAINS':
                operatorText = 'Includes: ';
                break;
            case 'NOT_IN':
            case 'NOT_CONTAINS':
                operatorText = 'Excludes: ';
                break;
            case 'MORE_THAN':
                operatorText = 'Greater than or equal to: ';
                break;
            case 'LESS_THAN':
                operatorText = 'Less than: ';
                break;
            case 'BEFORE':
                operatorText = 'Before: ';
                break;
            case 'AFTER':
                operatorText = 'After: ';
        }

        return operatorText;
    };

    const getValueText = () => {
        if (customText) return customText;
        return getReportFilterText(currentFilterConfiguration, filter, timeZone);
    };

    return (
        <div
            className={classNames('filter-pill', {
                'filter-pill--delete-hovered': isDeleteHovered,
                'filter-pill--selected': isSelected
            })}
            onClick={() => select(currentFilterConfiguration)}
        >
            <CloseIcon
                className='close-icon'
                onClick={() => clear(currentFilterConfiguration)}
                onMouseEnter={() => setIsDeleteHovered(true)}
                onMouseLeave={() => setIsDeleteHovered(false)}
            />
            <div className='filter-pill__content'>
                <Text className='filter-pill__label' message={currentFilterConfiguration.label}/>
                <div className='filter-pill__value'>
                    <Text message={getOperatorText()}/>
                    <span>{getValueText()}</span>
                </div>
            </div>
        </div>
    );
};

export default FilterPill;
